import React from 'react';
import Layout from './components/Layout';
import styles from './Profile.module.scss';

export default function Profile() {
  return <Layout />
}